import { List, ListItem, ListItemText, ListItemAvatar, Avatar } from '@mui/material';
import { Folder } from '@mui/icons-material';
import { getApplicationName } from '@gral/config';
import { Typography, Button, GridContainerFullHeight } from '@ts/storybook';
import { useTranslation } from 'react-i18next';
import { useAppDispatch, useAppSelector } from '@redux/store';
import { globalActions } from '@redux/slices/states/global/globalSlice';
import { postData } from '@redux/slices/functionals/request/requestActions';

const QuuppaSitePlanner = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const sessionBadge = useAppSelector(state => state.global.sessionBadge);

  const listItems = [
    {
      primary: 'Quuppa BLE Tags',
      secondary: "Requires an already created item type. Match made with 'Custom ID'",
    },
    {
      primary: 'Quuppa Locators',
      secondary: "Requires an already created item type. Match made with 'Custom ID'",
    },
    {
      primary: 'Zones and Tracking Areas',
      secondary: "Requires an already created item type. Match made with 'Custom ID'",
    },
    {
      primary: 'Background image, Layer and View',
      secondary: 'Requires layer and view names defined in the setting',
    },
    {
      primary: 'Tag Groups',
    },
  ];

  const onSend = () => {
    const url = '/api/quuppaSitePlannerImport';
    dispatch(
      postData({
        url,
        dataBody: {
          profileId: sessionBadge?.profileId,
        },
      })
    );

    dispatch(globalActions.notification(t('Importing Quuppa Site Planner project information') + '...'));
  };

  return (
    <GridContainerFullHeight p={2} spacing={2}>
      <Typography variant="h4" text="Quupa Site Planner" />
      <Typography
        variant="subtitle1"
        color="textPrimary"
        text={['This wizard tool imports Quuppa Site Planner projects into ', getApplicationName()]}
      />
      <Typography
        variant="subtitle1"
        color="textPrimary"
        text="It is necessary to have a defined 'quuppaSitePlannerConfig' custom setting with configuration details"
      />
      <Typography variant="subtitle1" color="textPrimary" text={['Entities that could be imported', ':']} />

      <List dense={true}>
        {listItems.map((o, i) => {
          return (
            <ListItem key={'list' + i}>
              <ListItemAvatar>
                <Avatar>
                  <Folder />
                </Avatar>
              </ListItemAvatar>
              <ListItemText primary={t(o.primary)} secondary={o.secondary && t(o.secondary)} />
            </ListItem>
          );
        })}
      </List>
      <Typography
        variant="subtitle2"
        color="textPrimary"
        text="In case any entity in QSP does not have the field 'id' well-defined will use 'name' field"
      />
      <Typography
        variant="subtitle2"
        color="textPrimary"
        text="In case of use 'name' field space characters (' ') will be replaced for underscore characters ('_')"
      />
      <Button onClick={onSend} type="submit" label="Import project info" />
    </GridContainerFullHeight>
  );
};

export default QuuppaSitePlanner;
